module.exports = __webpack_public_path__ + "static/media/Dragon-Victory.19a672f2.gif";